'use client';

import { c as _c } from "react/compiler-runtime";
import { captureException } from '@sentry/nextjs';
import { useEffect, useState } from 'react';
import { useSearchHistoryStore } from '@/app/_components/SearchBar/_store/searchHistoryStore';
import { ROUTES } from '@/constants';
import { useCustomRouter } from '@/hooks/useCustomRouter';
import { GTM_EVENT_TYPE, trackGtmEvent } from '@/utils/analytics/gtm';
import { postWelloTrack } from '@/utils/analytics/welloTrack';
import { useRollingStep } from './useRollingStep';
import { useTrendKeywords } from './useTrendKeywords';
export const useTrendKeyword = t0 => {
  const $ = _c(20);
  let t1;
  if ($[0] !== t0) {
    t1 = t0 === undefined ? {} : t0;
    $[0] = t0;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const {
    enabled: t2
  } = t1;
  const enabled = t2 === undefined ? true : t2;
  const [isOpen, setIsOpen] = useState(false);
  let t3;
  if ($[2] !== enabled) {
    t3 = {
      enabled
    };
    $[2] = enabled;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  const {
    keywords,
    isPending
  } = useTrendKeywords(t3);
  const step = useRollingStep(keywords.length, isOpen);
  const {
    push
  } = useCustomRouter();
  const addSearchHistory = useSearchHistoryStore(_temp);
  let t4;
  let t5;
  if ($[4] !== isOpen) {
    t4 = () => {
      if (!isOpen) {
        return;
      }
      const handleScroll = () => setIsOpen(false);
      window.addEventListener("scroll", handleScroll, {
        passive: true
      });
      return () => window.removeEventListener("scroll", handleScroll);
    };
    t5 = [isOpen];
    $[4] = isOpen;
    $[5] = t4;
    $[6] = t5;
  } else {
    t4 = $[5];
    t5 = $[6];
  }
  useEffect(t4, t5);
  let t6;
  if ($[7] !== addSearchHistory || $[8] !== keywords || $[9] !== push) {
    t6 = keyword => {
      setIsOpen(false);
      addSearchHistory(keyword);
      const ranking = keywords.find(item => item.keyword === keyword)?.ranking;
      const clickParams = {
        btn_name: "\uC6F0\uB85C \uD0A4\uC6CC\uB4DC",
        content_name: keyword,
        ranking
      };
      trackGtmEvent(GTM_EVENT_TYPE.CLICK_BTN, clickParams);
      postWelloTrack({
        eventName: "clickWelloKeyword",
        dictionary: {
          url: `${window.location.pathname}${window.location.search}`,
          keyword,
          ranking
        }
      }).catch(captureException);
      push(ROUTES.SEARCH.withSearchParams({
        searchParams: {
          q: keyword
        }
      }));
    };
    $[7] = addSearchHistory;
    $[8] = keywords;
    $[9] = push;
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  const search = t6;
  const t7 = keywords[step % keywords.length];
  let t8;
  let t9;
  if ($[11] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = () => setIsOpen(_temp2);
    t9 = () => setIsOpen(false);
    $[11] = t8;
    $[12] = t9;
  } else {
    t8 = $[11];
    t9 = $[12];
  }
  let t10;
  if ($[13] !== isOpen || $[14] !== isPending || $[15] !== keywords || $[16] !== search || $[17] !== step || $[18] !== t7) {
    t10 = {
      keywords,
      step,
      isOpen,
      isPending,
      currentKeyword: t7,
      search,
      toggle: t8,
      close: t9
    };
    $[13] = isOpen;
    $[14] = isPending;
    $[15] = keywords;
    $[16] = search;
    $[17] = step;
    $[18] = t7;
    $[19] = t10;
  } else {
    t10 = $[19];
  }
  return t10;
};
function _temp(state) {
  return state.add;
}
function _temp2(previousIsOpen) {
  return !previousIsOpen;
}